import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

import "../components/layout.css"
import { GTM_PROJECT_CATEGORY } from "../utils/constants";
import { getGtmUserType, fireGtmEvent } from "../utils/functions";

const StickyBar = styled.div`
 #button_div{
  background-color: #07d1e4;
  margin: 20px 20px 0 5px;
  padding: 20px;
  border-radius: 8px;
  color: #fff;
 }

 @media only screen and (max-width: 640px) {
   .App{
   width:80%;
  }

  #button_div{
    margin:0;
    width:100%;
    }
 }
`

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_button: true
    };
  }
  disable_button() {
    this.setState({ show_button: !this.state.show_button });
  }

  handleButtonClick = () => {
    // Fire GTM event
    fireGtmEvent({
      "event": "trackEventNoEcommerce",
     "eventDetails.category": "aa bigpay",
     "eventDetails.action": "click",
      "eventDetails.label": "sign up for bigpay"
      // Add any additional data or parameters you want to send with the event
    });
  };

  render() {
    
    return (
      <StickyBar>
      <div className="App">
        {this.state.show_button && (
          <div
            onClick={() => {
              
            }}
            id="button_div"
            className="btn"
            onClick={this.handleButtonClick}
          >
            <a href="https://bigpay.onelink.me/b8MO/8hom9zw2">Sign up for BigPay now!</a>
            <div className="content" id="close_button">
              <img
                style={{ width: "20px" }}
                src={("https://www.airasia.com/aa/images/web-apps/content-pages/library/btn-close.png")}
                alt="close icon"
                onClick={() => {
                  this.disable_button();
                }}
              />
            </div>
          </div>
        )}
      </div>
      </StickyBar>
    );
  }
}

export default App